import { render, staticRenderFns } from "./v3DisplayPage.vue?vue&type=template&id=641a1989"
import script from "./v3DisplayPage.vue?vue&type=script&lang=js"
export * from "./v3DisplayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports